import React from "react";

const ModelReport = (props) => {
  return (
    <div className="w-100 complete-contract">
      <div className="header-contract-land pt-3">
        <div className="row">
          <div className="col-md-3 d-flex justify-content-center">
            {props.logo && (
              <img
                src={props.logo}
                alt="logo"
                width={100}
                height={100}
                style={{ borderRadius: "20px" }}
              />
            )}
          </div>
          <div className="col-md-6 text-center pt-5">
            <h3 className="fw-bolder">{props.title}</h3>
          </div>
          <div className="col-md-3 d-flex justify-content-end pt-4 ">
            <div className="mx-3 text-center">
              <h6>{props.date}</h6>
              <p>Emitido por: {props.madeBy}</p>
              {props.legend && <>{props.legend}</>}
            </div>
          </div>
        </div>
        <div className="row text-center d-flex justify-content-center my-2">
          {(props.filters ?? []).map((item, index) => (
            <div className="w-auto my-2 text-start d-flex" key={index}>
              <h6 className="mx-3">
                <span
                  className="fw-bolder text-gray"
                  style={{ fontSize: "13px" }}
                >
                  {item.title}:{" "}
                </span>{" "}
                {item.content ? item.content.toString() : "N/A"}
              </h6>
              {index !== (props.filters?.length ?? 0) - 1 && (
                <span className="mx-1" style={{ translate: "0px -2px" }}>
                  |
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="content-contract-land">{props.children}</div>
    </div>
  );
};

export default ModelReport;
